export const getters = {
  blobEndpointServersList: ({ endpointList }) =>
    endpointList.filter((endpointServer) => endpointServer.Type === 'Blob'),
  sftpEndpointServersList: ({ endpointList }) => endpointList.filter((endpointServer) => endpointServer.Type !== 'Blob')
};
